import React from 'react';
import Box from '@mui/material/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import SuccessImg from '../../assets/200-ok.svg';

const SuccessDialog = ({ description, isSuccessDialog, setSuccessDialog }) => {
  return (
    <Dialog
      open={isSuccessDialog}
      onClose={() => setSuccessDialog(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Уведомление'}</DialogTitle>
      <DialogContent>
        <div style={{ minWidth: 500 + 'px' }}>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
          <Box
            component="div"
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <img
              alt="Изображение успешной операции"
              src={SuccessImg}
              style={{ width: '200px' }}
            />
          </Box>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setSuccessDialog(false)}
        >
          Хорошо
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
